<template>
  <div id="AddUser">
    <el-dialog :center="true" title="新增用户" :visible.sync="dialogVisible" width="500px" @close="resetForm('user')">
      <el-form :model="user" :rules="rules" ref="user" label-width="100px" class="demo-ruleForm">
        <el-form-item label="部门" v-model="user.departName">
          {{user.departName}}
        </el-form-item>
        <el-form-item label="编号">
          <el-input v-model="user.userCode" :disabled="isDisabled" placeholder="编号(自动生成)"></el-input>
        </el-form-item>
        <el-form-item label="姓名" prop="trueName">
          <el-input class="eb-input" v-model="user.trueName" placeholder="姓名"></el-input>
        </el-form-item>
        <el-form-item label="用户名" prop="showName">
          <el-input class="eb-input" v-model="user.showName" placeholder="用户名"></el-input>
        </el-form-item>
        <el-form-item label="密码" prop="userPassword">
          <el-input class="eb-input" v-model="user.userPassword" placeholder="密码"></el-input>
        </el-form-item>
        <el-form-item label="职务" prop="position">
          <el-input class="eb-input" v-model="user.position" placeholder="职务"></el-input>
        </el-form-item>
        <el-form-item label="手机号" prop="userPhone">
          <el-input class="eb-input" v-model="user.userPhone" placeholder="手机号"></el-input>
        </el-form-item>
        <el-form-item label="工作电话" prop="phone">
          <el-input class="eb-input" v-model="user.phone" placeholder="工作电话"></el-input>
        </el-form-item>
        <el-form-item label="邮件" prop="userEmail">
          <el-input class="eb-input" v-model="user.userEmail" placeholder="邮件"></el-input>
        </el-form-item>
        <el-form-item label="角色" prop="roleId">
          <el-radio-group v-model="user.roleId" v-for="role in roles" :key="role.id">
            <el-radio class="eb-radio radio" :label="role.id" @change="selectedCurrent">{{role.text}}</el-radio>
          </el-radio-group>
        </el-form-item>
        <div class="eb-button-group">
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="resetForm('user')">取消</el-button>
          <el-button class="eb-button-group-btn eb-button-orange eb-button-big" @click="confirmBtn('user')">确定</el-button>
        </div>
      </el-form>
    </el-dialog>
  </div>
</template>
<script>
import eventBus from '@/plugins/event-bus';
import { clone } from 'lodash';
import { USER_ROLE_GROUP, isHideRole, saveUser } from '@/services/user/user-service';
export default {
  name: 'AddUser',
  data() {
    let checkPhone = (rule, value, callback) => {
      let reg = /^[0-9-]*$/;
      if (!value) {
        callback();
      } else {
        if (!reg.test(value)) {
          callback(new Error('请输入有效的工作电话！'));
        } else {
          callback();
        }
      }
    };
    let checkUserPhone = (rule, value, callback) => {
      let reg = /^((13[0-9])|(14[5,7])|(15[0-3,5-9])|(17[0,3,5-8])|(18[0-9])|166|198|199|(147))\d{8}$/;
      if (!value) {
        callback(new Error('请输入手机号'));
      } else if (!reg.test(value)) {
        callback(new Error('请输入有效的手机号！'));
      } else {
        callback();
      }
    };
    return {
      dialogVisible: false,
      isDisabled: true,
      currentDept: {},
      user: {
        orgId: this.$store.state.user.userInfo.departId,
        isManage: 0
      },
      initUser: {
        orgId: this.$store.state.user.userInfo.departId,
        isManage: 0
      },
      roles: [],
      rules: {
        trueName: [
          { required: true, message: '请输入真实姓名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        showName: [
          { required: true, message: '请输入用户名', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在2 到 10 个字符', trigger: 'blur' }
        ],
        userPassword: [
          { required: true, message: '请输入密码', trigger: 'blur' },
          { min: 8, max: 16, message: '长度在 8 到 16 个字符', trigger: 'blur' }
        ],
        position: [
          { required: true, message: '请输入职务', trigger: 'blur' },
          { min: 2, max: 10, message: '长度在 2 到 10 个字符', trigger: 'blur' }
        ],
        userPhone: [{ required: true, validator: checkUserPhone, trigger: 'blur' }],
        phone: [
          { validator: checkPhone, trigger: 'blur' },
          { max: 20, message: '长度不能超过 20 个字符', trigger: 'blur' }
        ],
        userEmail: [
          { required: true, message: '请输入邮箱地址', trigger: 'blur' },
          { type: 'email', message: '请输入正确的邮箱地址', trigger: ['blur', 'change'] }
        ],
        roleId: [{ required: true, message: '请选择用户角色', trigger: 'change' }]
      }
    };
  },
  created() {
    eventBus.$on('addUser', depart => {
      this.user.departId = depart.departId;
      this.user.departName = depart.departName;
      this.dialogVisible = true;
    });
    this.init();
  },
  methods: {
    init() {
      let userRoleBusiness = USER_ROLE_GROUP.userRoleBusiness;
      let orgType = this.$store.state.user.userInfo.orgType;
      userRoleBusiness.forEach((item, index) => {
        let isHide = isHideRole(orgType, item.id);
        if (!isHide) {
          this.roles.push(item);
        }
      });
    },
    selectedCurrent: function(label) {
      this.user.roleId = label;
      this.user.userRoles = label;
    },
    confirmBtn(formName) {
      this.$refs[formName].validate(valid => {
        if (valid) {
          this.saveNewUser();
        } else {
          return false;
        }
      });
    },
    async saveNewUser() {
      try {
        this.user.userName = this.user.showName;
        let { data } = await saveUser(this.user);
        if (data.returnCode === '01') {
          this.$message.success('新增用户成功');
          this.dialogVisible = false;
          this.user = clone(this.initUser);
          eventBus.$emit('addOrEditDeptsuccess');
        } else if (data.returnCode === '05') {
          if (data.errorCode === '01') {
            this.$message.error('用户名已存在');
          }
          if (data.errorCode === '02') {
            this.$message.error('手机号码已存在');
          }
        } else {
          this.$message.error('新增用户失败');
        }
      } catch (error) {
        this.$message.error('请检查服务器连接！');
      }
    },
    resetForm: function(formName) {
      this.dialogVisible = false;
      this.$refs[formName].resetFields();
    }
  }
};
</script>
<style lang="less" scoped>
#AddUser {
  .radio {
    margin-right: 50px;
    margin-left: 20px;
  }
}
</style>
